import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

//push 
const VueRouterPush = VueRouter.prototype.push 
VueRouter.prototype.push = function push (location) {
    return VueRouterPush.call(this, location).catch(err => err)
}

//replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return VueRouterReplace.call(this, location).catch(err => err)
}

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   // redirect: '/',//设置默认指向的路径
  //   meta: {
  //     title: '吉客云-一站式数字化解决方案',
  //     keepAlive: true
  //   }
  // },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '吉客云官网｜企业一站式数字化解决方案！电商erp/云仓wms/产销一体化/业务财务办公一体化管理软件',
      keepAlive: true,
      content:{
        keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化',
        description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台',
      },
    }
  },
  {
    path: "/Solution",
    name: "Solution",
    component: () => import('../views/Solution.vue'),
    meta: {
      title: '解决方案-吉客云',
      keepAlive: true,
      content:{
        keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化',
        description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台',
      },
    }
  },
  {
    path: "/service",
    name: "service",
    component: () => import('../views/service.vue'),
    meta: {
      title: '服务中心-吉客云',
      keepAlive: true,
      content:{
        keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化',
        description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台',
      },
    }
  },
  {
    path: '/waitting',
    name: 'waitting',
    component: () => import('../views/waitting.vue'),
    meta: {
      title: '吉客云',
      keepAlive: false,
    }
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   redirect: '/brief',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import('../views/About.vue'),
  // },
    {
      path: '/development',
      name: 'Development',
      meta: {
        title: '吉客云官网｜关于我们--一站式数字化解决方案！业务财务办公一体化管理软件！',
        keepAlive: true,
        content:{
          keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化1',
          description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台1',
        },
      },
      component: () => import('../views/development.vue')
    },
    {
      path: '/culture',
      name: "culture",
      meta: {
        title: '吉客云官网｜关于我们--一站式数字化解决方案！业务财务办公一体化管理软件！',
        keepAlive: true,
        content:{
          keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化2',
          description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台2',
        },
      },
      component: () => import('../views/culture.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      meta: {
        title: '吉客云官网｜关于我们--一站式数字化解决方案！业务财务办公一体化管理软件！',
        keepAlive: true,
        content:{
          keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化3',
          description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台3',
        },
      },
      component: () => import('../views/contact.vue')
    },
    {
      path: "/honour",
      name: "honour",
      meta: {
        title: '吉客云官网｜关于我们--一站式数字化解决方案！业务财务办公一体化管理软件！',
        keepAlive: true,
        content:{
          keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化4',
          description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台4',
        },
      },
      component: () => import('../views/honour.vue')
    },
    {
      path: "/brief",
      name: "brief",
      meta: {
        title: '吉客云官网｜关于我们--一站式数字化解决方案！业务财务办公一体化管理软件！',
        keepAlive: true,
        content:{
          keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化5',
          description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台5',
        },
      },
      component: () => import('../views/brief.vue')
    },
  {
    path: "/notice",
    name: "notice",
    component: () => import('../views/Notice.vue'),
    meta: {
      title: '吉客云官网｜最新动态--一站式数字化解决方案！业务财务办公一体化管理软件！',
      keepAlive: true,
      content:{
        keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化6',
        description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台6',
      },
    }
  },
  {
    path: "/platform",
    name: "platform",
    component: () => import('../views/Platform.vue'),
    meta: {
      title: '吉客云官网｜平台对接--一站式数字化解决方案！业务财务办公一体化管理软件！',
      keepAlive: true,
      content:{
        keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化',
        description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台',
      },
    }
  },
  {
    path: "/videos",
    name: "videos",
    component: () => import('../views/Videos.vue'),
    meta: {
      title: '吉客云官网｜更多视频--一站式数字化解决方案！业务财务办公一体化管理软件！',
      keepAlive: true,
      content:{
        keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化',
        description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台',
      },
    }
  },
  {
    path: '/custom',
    name: 'custom',
    component: () => import('../views/Custom.vue'),
    meta: {
      title: '吉客云官网｜典型客户--一站式数字化解决方案！业务财务办公一体化管理软件！',
      keepAlive: true,
      content:{
        keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化',
        description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台',
      },
    }
  },
  {
    path: '/yunClass',
    name: 'yunClass',
    component: () => import('../views/yunClass.vue'),
    meta: {
      title: '吉客云官网｜云课堂--领先的电商ERP/电商云仓WMS/生产管理解决方案/数字化转型落地工具服务商',
      keepAlive: true,
      content:{
        keywords:'云课堂-吉客云',
        description:'云课堂-吉客云',
      },
    }
  },
  {
    path: '/yunClass-detail',
    name: 'yunClass-detail',
    component: () => import('../views/yunClass-detail.vue'),
    meta: {
      title: '吉客云官网｜云课堂--领先的电商ERP/电商云仓WMS/生产管理解决方案/数字化转型落地工具服务商',
      keepAlive: true,
      content:{
        keywords:'云课堂-吉客云',
        description:'云课堂-吉客云',
      },
    }
  },
  {
    path: '/calculator1',
    name: 'calculator',
    component: () => import('../views/calculator.vue'),
    meta: {
      title: '吉客云官网｜价格计算器--领先的电商ERP/电商云仓WMS/生产管理解决方案/数字化转型落地工具服务商',
      keepAlive: true,
      content:{
        keywords:'价格计算器-吉客云',
        description:'价格计算器-吉客云',
      },
    }
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: () => import('../views/statistics.vue'),
    meta: {
      title: '吉客云官网｜销售单数据--领先的电商ERP/电商云仓WMS/生产管理解决方案/数字化转型落地工具服务商',
      keepAlive: false,
      sideTipAlive:true,
      content:{
        keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化',
        description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台',
      },
    }
  },
  {
    path: '/sell',
    name: 'sell',
    redirect: '/sell/jikeyun',
    component: () => import('../views/Sell.vue'),
    children: [
      {
        path: 'jikeyun',
        name: 'jikeyun',
        meta: {
          title: '销售政策-吉客云',
          keepAlive: true,
          content:{
            keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化',
            description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台',
          },
        },
        component: () => import('../views/sell/jikeyun.vue')
      },
      {
        path: 'hardsoft',
        name: 'hardsoft',
        meta: {
          title: '销售政策-吉客云',
          keepAlive: true,
          content:{
            keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化',
            description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台',
          },
        },
        component: () => import('../views/sell/hardsoft.vue')
      },
      {
        path: 'sceneserve',
        name: 'sceneserve',
        meta: {
          title: '销售政策-吉客云',
          keepAlive: true,
          content:{
            keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化',
            description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台',
          },
        },
        component: () => import('../views/sell/sceneserve.vue')
      },

    ]
  },

  {
    path: '/recruitment',
    name: 'recruitment',
    component: () => import('../views/recruitment.vue'),
    meta: {
      title: '吉客云官网｜人才招募--领先的电商ERP/电商云仓WMS/生产管理解决方案/数字化转型落地工具服务商',
      keepAlive: true,
      content:{
        keywords:'电商erp、电商仓库管理wms软件、生产管理MRP系统、数字化转型落地工具、企业管理软件、业务财务一体化',
        description:'吉客云，全渠道订单、仓库、生产、CRM、财务、办公人事一体化管理软件，为企业打造研产供销数字化闭环！对接了阿里、京东、拼多多、抖音、快手、唯品会、有赞、微盟等300多家电商平台',
      },
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})
router.beforeEach(function (to, from, next) {
    /* 路由发生变化修改页面meta */
    // if(to.meta.content){
    //   let head = document.getElementsByTagName('head');
    //   let meta = document.createElement('meta');
    //   document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    //   document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    //   meta.content = to.meta.content;
    //   head[0].appendChild(meta)
    // }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // if(0 === to.matched.length||to.name === 'root'){
  //   next({path:'/'})
  //   return
  // }
  next()
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js